import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { Flex, Box } from 'grid-styled'
import { utils } from 'alelo-logic'
import Button from '../../elements/Button'
import { renderTextInput, renderCnpjInput, renderCheckboxField } from '../../../utils/renderInputs'

import { Container } from '../EditUserDataForm/styles'

import { labels } from './data.json'

const { currencyParser } = utils

const EditCompanyDataForm = props => {
  const { handleSubmit, saving } = props

  return (
    <form onSubmit={handleSubmit}>
      <Container>
        <Flex wrap width={[1, 7 / 12]}>
          <Box width={1} mb={3}>
            <Field
              component={renderTextInput}
              label={labels.name}
              name="name"
              type="text"
              validate={utils.emptyFieldValidate}
              isRequired
            />
          </Box>
          <Box width={1} mb={3}>
            <Field
              component={renderCnpjInput}
              label={labels.cnpj}
              name="cnpj"
              type="text"
              normalize={utils.cnpjMask}
              validate={utils.cnpjValidate}
              disabled
              isRequired
            />
          </Box>
          <Box width={1} mb={3}>
            <Field
              component={renderTextInput}
              label={labels.companyName}
              name="companyName"
              type="text"
              validate={utils.emptyFieldValidate}
              disabled
              isRequired
            />
          </Box>
          <Box width={1} mb={3}>
            <Field
              component={renderTextInput}
              label={labels.foc}
              name="foc"
              type="text"
              validate={utils.emptyFieldValidate}
              disabled
              isRequired
            />
          </Box>
          <Box width={[1, 1 / 2]} pr={[0, 2]} mb={3}>
            <Field
              component={renderTextInput}
              label={labels.doc}
              name="doc"
              type="text"
              validate={utils.dateBeforeTodayValidate}
              normalize={utils.dateMask}
              disabled
              isRequired
            />
          </Box>

          <Box width={[1, 1 / 2]} pl={[0, 2]} mb={3}>
            <Field
              component={renderTextInput}
              label={labels.cnae}
              name="cnae"
              type="text"
              normalize={utils.numberMask}
              validate={utils.emptyFieldValidate}
              isRequired
            />
          </Box>
          <Box width={[1, 1 / 2]} pr={[0, 2]} mb={3}>
            <Field
              component={renderTextInput}
              label={labels.registration}
              name="registration"
              type="text"
              validate={utils.emptyFieldValidate}
              disabled
              isRequired
            />
          </Box>
          <Box width={[1, 1 / 2]} pl={[0, 2]} mb={3}>
            <Field
              component={renderTextInput}
              label={labels.income}
              name="income"
              type="text"
              isRequired
              format={value => currencyParser(value, '', true)}
              lockCursor
            />
          </Box>
          <Box width={1} mb={3}>
            <Field
              component={renderCheckboxField}
              label={labels.pap}
              name="pap"
              disabled={saving}
            />
          </Box>
        </Flex>
      </Container>
      <Container>
        <Button type="submit" text="Salvar" disabled disabled={saving} loading={saving} />
      </Container>
    </form>
  )
}

const mapStateToProps = state => {
  return {
    saving: state.reducer.formState.saving
  }
}

const form = reduxForm({
  form: 'editCompanyData',
  enableReinitialize: true,
  destroyOnUnmount: false
})(EditCompanyDataForm)

export default connect(mapStateToProps, undefined)(form)



// WEBPACK FOOTER //
// ./src/app/modules/EditCompanyDataForm/index.js